"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canCreatePriceModels = void 0;

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
/* eslint import/prefer-default-export: "off" */


var getSub = function getSub(accessToken) {
  try {
    var jwt = (0, _jwtDecode.default)(accessToken);

    if (jwt) {
      return jwt.sub;
    }

    return null;
  } catch (e) {
    return null;
  }
};

var canCreatePriceModels = function canCreatePriceModels(onGetAccessToken, fulfillerId) {
  if (!fulfillerId) {
    return false;
  }

  var accessToken = onGetAccessToken();
  var sub = getSub(accessToken);

  if (!sub) {
    return false;
  }

  var headers = new Headers({
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken)
  });
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: headers
  };
  var url = "https://api.cimpress.io/auth/access-management/v1/principals/".concat(encodeURIComponent(sub), "/permissions/fulfillers/").concat(fulfillerId);
  return fetch(url, options).then(function (res) {
    if (res.ok) {
      return res.json();
    }

    throw res;
  }).then(function (res) {
    if (res.permissions && res.permissions.includes('create:price-models') && res.permissions.includes('update:price-models')) {
      return true;
    }

    return false;
  }).catch(function () {
    return false;
  });
};

exports.canCreatePriceModels = canCreatePriceModels;